export default __webpack_public_path__ + "static/media/fastingtimer@3x.12b1cdb9.jpg";